import * as React from 'react';
import { Dropdown, Input } from 'semantic-ui-react';
import { SearchData, ISearchData } from '../../models';
import { FuzzySearch, GenerateCheckboxes, DateRangeSelector } from '..';
import { SearchBar } from '../SearchBar';
import styles from './Filter.module.scss';

interface IFilterSmallProps {
    onSearch: any;
    searchText: any;
    applyFitlers: any;
    fuzzySearch: any;
}
interface IFilterSmallState {
    author: string[],
    title: string[],
    divisionClicked: boolean;
    documentClicked: boolean;
    agencyClicked: boolean;
    agency: any;
    agencySelected: string;
    division: ISearchData[];
    documentType: ISearchData[];
    cleared: boolean;
}

export class FilterSmall extends React.Component<IFilterSmallProps, IFilterSmallState> {

    private searchData = new SearchData();

    constructor(props: IFilterSmallProps) {
        super(props);

        this.state = {
            author: [''],
            title:[''],
            divisionClicked: false,
            documentClicked: false,
            agencyClicked: false,
            agency: '',
            agencySelected: '',
            division: [],
            documentType: [],
            cleared: false
        }
    }


    async componentDidMount() {
        this.setState({
            division: await this.searchData.Division(),
            documentType: await this.searchData.DocumentType(),
            agency: await this.searchData.Agency(),
            agencySelected: JSON.parse(localStorage.getItem('agency') || ''),
            author: [JSON.parse(localStorage.getItem('author') || '')],
            title: [JSON.parse(localStorage.getItem('title') || '')]
        });
    }

    async componentDidUpdate(prevProps: IFilterSmallProps, prevState: IFilterSmallState) {
        if (prevState.cleared != this.state.cleared && this.state.cleared) {
            this.setState({
                author: JSON.parse(localStorage.getItem('author') || ''),
                title: JSON.parse(localStorage.getItem('title') || ''),
                division: await this.searchData.Division(),
                documentType: await this.searchData.DocumentType(),
                agency: await this.searchData.Agency(),
                agencySelected: JSON.parse(localStorage.getItem('agency') || ''),
                cleared: false
            });
            this.forceUpdate();
        }
    }

    public render() {
        let _end  = JSON.parse(localStorage.getItem('endDate') || 'null');
        let _start = JSON.parse(localStorage.getItem('startDate') || 'null');
        
        return (
            <div className={styles.filter}>
                <SearchBar searchTextProp={this.props.onSearch} searchText={this.props.searchText} cleared={this.state.cleared} />
                <label className={styles.applyFilters} onClick={this.props.applyFitlers} >Apply filters</label>
                <label className={styles.clearFilters} onClick={this.onClearSearchBox.bind(this)}>Clear all filters</label>
                <FuzzySearch className={styles.non} />
                <div className={styles.authorTitleFilter}>
                    <h4>Filter by Exact Author or Title</h4>
                    <Input placeholder='Author Test' value={this.state.author[0]} onChange={(event, data) => this.onAuthorHandleChange(event, data)}></Input>
                    <Input placeholder='Title Test' value={this.state.title[0]} onChange={(event, data) => this.onTitleHandleChange(event, data)}></Input>
                </div>
                <div className={styles.dateRange}>
                    <h4>Search Date Range</h4>
                    {this.state.cleared ? <div /> :
                        <DateRangeSelector
                            startDate={_start}
                            endDate={_end == null ? _start : _end } />
                    }
                </div>
                {this.wrapCheckboxes('Document Type', this.state.documentType, this.state.documentClicked, this.onDocumentClick.bind(this))}
                {this.wrapCheckboxes('Division', this.state.division, this.state.divisionClicked, this.onDivisionClick.bind(this))}

                {this.state.agency.length > 0 ?
                    <>
                        <h4>Agency</h4>
                        {this.state.cleared ? <div /> : <>
                            <Dropdown placeholder='Agency' search button fluid multiple selection options={this.state.agency} value={this.state.agencySelected} onChange={(e, d) => this.onAgencyHandleChange(e, d)} className={styles.dropDownSelection} />
                        </>
                        }
                    </> : <div />}
            </div>
        );
    }

    private wrapCheckboxes(title: string, data: ISearchData[], clicked: boolean, onClick: any) {
        if (data.length > 0) {
            return (
                <>
                    <h4>{title}</h4>
                    {this.state.cleared ? <div /> :
                        <div className={styles.checkboxContainer}>
                            <GenerateCheckboxes searchData={data} title={title} />
                        </div>
                    }
                </>
            )
        }

        return <div />;
    }

    private onDivisionClick() {
        this.setState({
            divisionClicked: !this.state.divisionClicked
        });
    }

    private onDocumentClick() {
        this.setState({
            documentClicked: !this.state.documentClicked
        });
    }

    private onAuthorHandleChange(event: any, data: any){
        this.setState({
            author: [data.value]
        })
        localStorage.setItem("author", JSON.stringify(data.value ? [data.value] : []));
    }

    private onTitleHandleChange(event: any, data: any){
        this.setState({
            title: [data.value]
        })
        localStorage.setItem("title", JSON.stringify(data.value? [data.value] : []));
    }

    private onAgencyHandleChange(event: any, data: any) {
        this.setState({
            agencySelected: data.value
        });

        localStorage.setItem('agency', JSON.stringify(data.value));
    }

    private onClearSearchBox() {
        localStorage.setItem('author', JSON.stringify([]));
        localStorage.setItem('title', JSON.stringify([]));
        localStorage.setItem('startDate', JSON.stringify('null'));
        localStorage.setItem('endDate', JSON.stringify('null'));
        localStorage.setItem('division', JSON.stringify([]));
        localStorage.setItem('agency', JSON.stringify([]));
        localStorage.setItem('documentType', JSON.stringify([]));
        localStorage.setItem("agency", JSON.stringify('non'));

        this.setState({
            author: [''],
            title: [''],
            cleared: true
        });
    }
}